import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    reason: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (fieldErrors[e.target.name]) {
      setFieldErrors({ ...fieldErrors, [e.target.name]: '' });
    }
  };

  const validate = () => {
    const errors = {};

    if (!form.firstName.trim()) errors.firstName = 'First name is required.';
    if (!form.lastName.trim()) errors.lastName = 'Last name is required.';

    if (!form.email.trim()) {
      errors.email = 'Email address is required.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(form.email.trim())) {
      errors.email = 'Please enter a valid email address.';
    }

    if (!form.phone.trim()) {
      errors.phone = 'Phone number is required.';
    } else if (!/^\+?[\d\s\-().]{7,15}$/.test(form.phone.trim())) {
      errors.phone = 'Please enter a valid phone number.';
    }

    if (!form.reason) errors.reason = 'Please select a topic.';
    if (!form.message.trim()) errors.message = 'Message is required.';

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    setSending(true);
    setError('');

    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      {
        first_name: form.firstName,
        last_name: form.lastName,
        email: form.email,
        phone: form.phone,
        reason: form.reason,
        message: form.message,
      },
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    ).then(() => {
      setSubmitted(true);
    }).catch(() => {
      setError('Something went wrong. Please try again or contact us directly.');
    }).finally(() => {
      setSending(false);
    });
  };

  return (
    <div className="contact">
      <div className="contact-left">
        <p className="contact-label">Reach Out</p>
        <h2 className="contact-heading">Book a Session</h2>
        <hr className="contact-rule" />
        <p className="contact-subtext">
          Reaching out is often the hardest part — and the most meaningful one. I personally respond within
          1–2 business days. No pressure, no commitment, just an honest conversation about how I can support you.
        </p>

        <div className="contact-info">
          <div className="contact-item">
            <div className="contact-icon">
              <img src="/images/icon-phone.svg" alt="" />
            </div>
            <div className="contact-item-text">
              <h4>Phone</h4>
              <a href="tel:6122948303">(612) 294-8303</a>
            </div>
          </div>

<div className="contact-item">
            <div className="contact-icon">
              <img src="/images/icon-location.svg" alt="" />
            </div>
            <div className="contact-item-text">
              <h4>Location</h4>
              <address style={{ fontStyle: 'normal' }}>5353 Wayzata Blvd, Suite 202<br />Saint Louis Park, MN 55416</address>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">
              <img src="/images/icon-languages.svg" alt="" />
            </div>
            <div className="contact-item-text">
              <h4>Languages</h4>
              <p>English · Russian · Ukrainian</p>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-right">
        {submitted ? (
          <div className="contact-success">
            Thank you! Anna will be in touch within 1–2 business days.
          </div>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit} noValidate>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">First Name</label>
                <input type="text" id="firstName" name="firstName" placeholder="Jane" value={form.firstName} onChange={handleChange} />
                {fieldErrors.firstName && <span className="field-error">{fieldErrors.firstName}</span>}
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Last Name</label>
                <input type="text" id="lastName" name="lastName" placeholder="Smith" value={form.lastName} onChange={handleChange} />
                {fieldErrors.lastName && <span className="field-error">{fieldErrors.lastName}</span>}
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" name="email" placeholder="jane@example.com" value={form.email} onChange={handleChange} />
              {fieldErrors.email && <span className="field-error">{fieldErrors.email}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input type="tel" id="phone" name="phone" placeholder="(612) 555-0000" value={form.phone} onChange={handleChange} />
              {fieldErrors.phone && <span className="field-error">{fieldErrors.phone}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="reason">What brings you here?</label>
              <select id="reason" name="reason" value={form.reason} onChange={handleChange}>
                <option value="">Select a topic…</option>
                <option>Anxiety or Depression</option>
                <option>Trauma or PTSD</option>
                <option>Grief or Loss</option>
                <option>Life Transitions</option>
                <option>Parenting Challenges</option>
                <option>Career Counseling</option>
                <option>Other</option>
              </select>
              {fieldErrors.reason && <span className="field-error">{fieldErrors.reason}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" placeholder="Tell Anna a little about what you're hoping to work on…" value={form.message} onChange={handleChange} />
              {fieldErrors.message && <span className="field-error">{fieldErrors.message}</span>}
            </div>
            {error && <p className="contact-error">{error}</p>}
            <button type="submit" className="contact-submit" disabled={sending}>
              {sending ? 'Sending…' : 'Send Message'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Contact;